import { gql } from '@apollo/client';

export const SIGN_AVATAR_MUTATION = gql`
  mutation SignAvatar($data: SignAvatarInput!) {
    signAvatar(data: $data) {
      signature
      nonce
    }
  }
`;
